import { Checkbox } from "@mui/material";
import { TemplateByCropGroup } from "../Utilities";
import { useEffect, useState } from "react";

interface Props {
  key: string;
  availableTemplate: TemplateByCropGroup | null;
  cropGroupSelected: string | null;
}

export default function TemplateCheckbox(props: Props) {
  const [selected, setSelected] = useState(
    props.availableTemplate.selectedForDownload,
  );

  // Quando cropGroupSelected cambia, aggiorniamo la checkbox
  useEffect(() => {
    setSelected(props.availableTemplate.selectedForDownload);
  }, [props.cropGroupSelected, props.availableTemplate.selectedForDownload]);

  return (
    <div key={props.key}>
      {props.availableTemplate.downlodable ? (
        <div>
          <Checkbox
            key={"check-" + props.key}
            checked={selected} // Usa checked invece di defaultChecked
            onChange={(event) => {
              const newValue = event.target.checked;
              setSelected(newValue); // Aggiorna lo stato locale
              props.availableTemplate.selectedForDownload = newValue; // Aggiorna il valore originale
              console.log("Updated selectedForDownload:", newValue);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
          {props.availableTemplate.aspectRatio} -{" "}
          {props.availableTemplate.label}
        </div>
      ) : (
        <div className="text-slate-500">
          <Checkbox key={"check" + props.key} disabled />
          {props.availableTemplate.aspectRatio} -{" "}
          {props.availableTemplate.label}
        </div>
      )}
    </div>
  );
}
